export default() => {
    const sidebar = $('.location-page__side-bar');

    // Early Exit if class not found
    if (sidebar.length === 0) {
        return;
    }

    const header = jQuery('.header');

    $(window).on('scroll resize', function() {
        const wpAdminBar = jQuery('#wpadminbar');
        let top = inViewport(header);

        if (wpAdminBar.length) {
            top = top + wpAdminBar.outerHeight();
        }

        sidebar.css('top', `${top}px`);
    });

    const inViewport = ($el) => {
        const elementOuterHeight = $el.outerHeight(),
            windowHeight = $(window).height(),
            boundingClient = $el[0].getBoundingClientRect(),
            top = boundingClient.top,
            bottom = boundingClient.bottom;

        return Math.max(0, top > 0 ? Math.min(elementOuterHeight, windowHeight - top) : Math.min(bottom, windowHeight));
    }
}
